<template>
  <input
    v-model="value"
    class="input input-reset"
    @focus="handleFocus"
    @blur="handleSaveOnBlur"
    @keyup.enter="handleSaveOnEnterKey"
    maxlength="25"
  >
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'EditTitle',
  props: ['defaultValue'],
  data () {
    return {
      oldValue: ''
    }
  },
  methods: {
    handleFocus (event) {
      this.oldValue = event.target.value
    },
    handleSave(event) {
      const valueIsChanged = event.target.value !== this.oldValue

      const onSuccess = () => this.$message.success('Название сохранено')
      const onError = () => this.$message.error('Ошибка при сохранении. Перезагрузите страницу')

      // console.log(
      //   valueIsChanged,
      //   event.target.value,
      //   this.oldValue
      // )

      if(valueIsChanged) {
        this.$store.dispatch('updateGroup', event.target.value)
          .then(onSuccess)
          .catch(onError)
      }
    },
    handleSaveOnBlur (event) {
      this.handleSave(event)
    },
    handleSaveOnEnterKey (event) {
      event.target.blur()
    }
  },
  computed: {
    value: {
      get() {
        return this.defaultValue
      },
      set(value) {
        console.log('value',value)
        this.$store.commit('setCurrentGroup',  {
          ...this.$store.state.currentGroup,
          name: value
        })
        this.$store.commit('getCurrentGroup', {id:this.$store.state.currentGroup.id, name: value })
      }
    }
  }
}
// get it
</script>

<style scoped lang="scss">
@import '../css/var';

.input {
  min-height: 44px;
  margin-bottom: .5em;
  color: rgba(0, 0, 0, 0.85);
  font-size: 28px;
  font-weight: 500;
  margin-left: -10px;
  padding-left: 10px;

  @include transition;
  border-radius: 4px;

  &:hover {
    // background: rgba(24,144,255, .05);
    box-shadow: 0 0 0 1px rgba(24,144,255, .2);
  }

  &:focus {
    // background: rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 0 2px #40a9ff;
  }
}

.input-reset {
  outline: none;
  width: 100%;
  border: none;
  overflow-wrap: break-word;
  -webkit-appearance: none;
}
</style>